import Banner from '@/components/sections/banner'
import CollectionLanding from '@/components/sections/collection-landing'
import CraftedToMatter from '@/components/sections/crafted-to-matter'
import Download from '@/components/sections/download'
import EditorialFullscreen from '@/components/sections/editorial-fullscreen'
import EditorialHorizontalGallery from '@/components/sections/editorial-horizontal-gallery'
import EditorialHorizontalText from '@/components/sections/editorial-horizontal-text'
import EditorialRelated from '@/components/sections/editorial-related'
import EditorialVerticalGallery from '@/components/sections/editorial-vertical-gallery'
import EditorialVerticalText from '@/components/sections/editorial-vertical-text'
import Hero from '@/components/sections/hero'
import ImageHero from '@/components/sections/image-hero'
import ImageText from '@/components/sections/image-text'
import Manifesto from '@/components/sections/manifesto'
import MediaCenter from '@/components/sections/media-center'
import ProductHero from '@/components/sections/product-hero'
import ProjectCredits from '@/components/sections/project-credits'
import QuickCollectionMenu from '@/components/sections/quick-collection-menu'
import RelatedProducts from '@/components/sections/related-products'
import RelatedStuff from '@/components/sections/related-stuff'
import SingleMedia from '@/components/sections/single-media'
import Spacer from '@/components/sections/spacer'
import SustainabilityNumbers from '@/components/sections/sustainability-numbers'
import SustainabilityPush from '@/components/sections/sustainability-push'
import SustainabilitySlider from '@/components/sections/sustainability-slider'
import SystemList from '@/components/sections/system-list'
import Team from '@/components/sections/team'
import TextHero from '@/components/sections/text-hero'
import Timeline from '@/components/sections/timeline'
import VideoPlayer from '@/components/sections/video-player'

export const sectionsMap: any = {
  product_hero: ProductHero,
  editorial_horizontal_gallery: EditorialHorizontalGallery,
  editorial_vertical_gallery: EditorialVerticalGallery,
  editorial_horizontal_text: EditorialHorizontalText,
  editorial_vertical_text: EditorialVerticalText,
  editorial_related: EditorialRelated,
  banner: Banner,
  text_hero: TextHero,
  image_hero: ImageHero,
  image_text: ImageText,
  manifesto: Manifesto,
  media_center: MediaCenter,
  collection_landing: CollectionLanding,
  video: VideoPlayer,
  download: Download,
  editorial_fullscreen: EditorialFullscreen,
  hero: Hero,
  project_credits: ProjectCredits,
  related_stuff: RelatedStuff,
  related_products: RelatedProducts,
  system_list: SystemList,
  spacer: Spacer,
  sustainability_slider: SustainabilitySlider,
  sustainability_numbers: SustainabilityNumbers,
  sustainability_push: SustainabilityPush,
  crafted_to_matter: CraftedToMatter,
  quick_collection_menu: QuickCollectionMenu,
  timeline: Timeline,
  team: Team,
  single_media: SingleMedia
}
